var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.item.nome),expression:"item.nome"}],staticClass:"bemfeitoria-icon"},[_c('img',{attrs:{"src":_vm.getIcone()}}),(_vm.item.quantidade > 1)?_c('div',{staticClass:"quantidade"},[_vm._v(_vm._s(_vm.item.quantidade))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }